import {ChangeDetectionStrategy, Component, Injectable, input, viewChildren} from "@angular/core";
import {BeslutningModell} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {BeslutningListevisningKompaktKomponent} from "../beslutning-listevisning-kompakt/beslutning-listevisning-kompakt";
import {delay} from "rxjs/operators";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";
import {BeslutningDatatjeneste} from "felles-ng2/tjenester/datalager/BeslutningDatatjeneste";
import {Observable} from "rxjs";

const debug = initDebugger('BeslutninglisteKompaktKomponent');

/**
 * Lister beslutninger i kompakt form
 */
@Component({
    selector: 'beslutningliste-kompakt',
    templateUrl: 'beslutningliste-kompakt.html',
    styleUrl: 'beslutningliste-kompakt.scss',
    imports: [
        BeslutningListevisningKompaktKomponent
    ],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BeslutninglisteKompaktKomponent {

    beslutningElementer = viewChildren(BeslutningListevisningKompaktKomponent);

    beslutninger = input.required<BeslutningModell[]>();

    constructor(private avhengigheter: BeslutninglisteKompaktKomponentAvhengigheter) {
        this.fokuserVedNyopprettet();
    }

    //private hjelpemetoder

    /** scroll til og blink når ny beslutninger opprettes */
    private fokuserVedNyopprettet() {
        this.avhengigheter.vedNyBeslutning
          .pipe(
            delay(100), //slik at den nye oppgave rekker å bli tegnet ut
            takeUntilDestroyed())
          .subscribe(nyBesluting =>
            this.beslutningElementer()
              .find(element => element.beslutning().id === nyBesluting.id)
              ?.fokuser());
    }
}


@Injectable()
export class BeslutninglisteKompaktKomponentAvhengigheter {

    constructor(private beslutningDatatjeneste: BeslutningDatatjeneste) {
    }

    get vedNyBeslutning(): Observable<BeslutningModell> {
        return this.beslutningDatatjeneste.vedNyBeslutning;
    }
}
